import React, { useContext, useState, useEffect } from 'react'
import { get as lGet } from 'lodash'
import { AuthContext } from '../../../../app'
import {
  apiCreateWarehouse,
  apiGetAllCompanies,
  apiGetCompanyFromId,
  apiGetWarehouseFromId,
  apiUpdateWarehouseDetails
} from '../../../../utils/api'

import {
  IsShortNameValid,
  isInteger
 } from '../utils'
import { 
  ERROR_MESSAGE_OF_DUPLICATE_WAREHOUSE
} from './constants'
import { 
  SIMULATION_TIMEOUT
} from '../../../../utils/constants'

import { CircularProgress } from '@mui/material'

import ModalTitleLabel from '../../../atoms/ModalTitleLabel'
import ErrorMessage from '../../../atoms/ErrorMessage'
import InputForm from '../../../molecules/InputForm'
import SelectInputForm from '../../../molecules/SelectInputForm'
import ModalButtonsSet from '../../../molecules/ModalButtonsSet'

const EditWarehouseModal = (props) => {
  const { targetId, closeEditModal } = props
  const { userDetails } = useContext(AuthContext)
  const userCompanyId = userDetails['company_id']
  const userRole = userDetails['role']

  const [name, setName] = useState('')
  const [shortName, setShortName] = useState('')
  const [companiesList, setCompaniesList] = useState([])
  const [belongsCompanyListNo, setBelongsCompanyListNo] = useState(0)
  const [limitSimulationSec, setlimitSimulationSec] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false)
  const [isInProgress, setIsInProgress] = useState(false)

  const isNameEmpty = !name || !shortName
  const disabled = isNameEmpty || !limitSimulationSec
  const isEditMode = !!targetId
  const modalTitle = isEditMode ? 'title_edit_warehouse' : 'title_create_warehouse'

  const fetchWarehouseFromId = async (companiesDetail=null) => {
    const {
      data: { data: companyDetails },
    } = await apiGetWarehouseFromId(targetId)
    const { name, short_name, company_id, limit_simulation_sec } = companyDetails[0]

    const rowCompaniesList = !!companiesList[0] ? companiesList : companiesDetail
    const companyIdList = rowCompaniesList.map(company => company['id'])
    const companyNo = companyIdList.indexOf(company_id)

    setName(name)
    setShortName(short_name)
    setBelongsCompanyListNo(companyNo)
    setlimitSimulationSec(limit_simulation_sec)
  }

  const fetchCompaniesData = async () => {
    const {
      data: { data: companiesDetail },
    } = (userRole === 'admin')
      ? await apiGetAllCompanies()
      : await apiGetCompanyFromId(userCompanyId)
    setCompaniesList(companiesDetail)

    // 編集モード
    if (isEditMode)
    {
      fetchWarehouseFromId(companiesDetail)
    
    // 新規登録モード
    } else {
      setlimitSimulationSec(SIMULATION_TIMEOUT)
    }

  }

  const initData = async () => {
    await fetchCompaniesData()
  }

  useEffect(() => {
    initData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createWarehouseSubmit = async (e) => {
    setIsInProgress(true)
    try {
      await apiCreateWarehouse({
        name: name,
        short_name: shortName,
        company_id: companiesList[belongsCompanyListNo]['id'],
        limit_simulation_sec: limitSimulationSec,
      })
      window.location.reload()
    } catch (e) {
      const responseMessage = lGet(e, 'response.data.message')
      if (responseMessage === 'RECAPTCHA_ERROR') {
        setErrorMessage('Error occurred validating captcha. Please try again')
      } else if (responseMessage === ERROR_MESSAGE_OF_DUPLICATE_WAREHOUSE) {
        setErrorMessage('warehouse_duplicated')
      }
      setRefreshReCaptcha(!refreshReCaptcha)
      // console.log(e)
    }
    setIsInProgress(false)
  }

  const editWarehouseSubmit = async (targetWarehouseId) => {
    setIsInProgress(true)
    try {
      await apiUpdateWarehouseDetails({
        name: name,
        short_name: shortName,
        company_id: companiesList[belongsCompanyListNo]['id'],
        limit_simulation_sec: limitSimulationSec,
        id: targetWarehouseId,
      })
      window.location.reload()
    } catch (e) {
      const responseMessage = lGet(e, 'response.data.message')
      if (responseMessage === 'RECAPTCHA_ERROR') {
        setErrorMessage('Error occurred validating captcha. Please try again')
      } else if (responseMessage === ERROR_MESSAGE_OF_DUPLICATE_WAREHOUSE) {
        setErrorMessage('warehouse_duplicated')
      }
      setRefreshReCaptcha(!refreshReCaptcha)
      // console.log(e)
    }
    setIsInProgress(false)
  }

  const returnIsError = () => {
    const isShortNameCorrect = IsShortNameValid(shortName)
    if (!!shortName && !isShortNameCorrect) {
      setErrorMessage('warehouse_short_name_validation_error')
      return true
    } else if (!isInteger(limitSimulationSec)){
      setErrorMessage('warehouse_limit_simulation_sec_error')
      return true
    } else {
      return false
    }
  }

  const handleRegisterWarehouse = async () => {
    const isError = await returnIsError()
    if (!isError) {
      if (isEditMode) {
        editWarehouseSubmit(targetId)
      } else {
        createWarehouseSubmit()
      }
    }
  }

    return (
      <div className='modal-wrapper'>
        <div
          className='modal-contents'
          onClick={e => { e.stopPropagation() }}
          style={{
            position: 'relative',
            opacity: isInProgress ? '.8' : '1'
          }}
        >
          <ModalTitleLabel i18nKey={modalTitle} />
          <div>
            <div className='flex'>
              <div className='input-wrapper half-width mr-4'>
                <InputForm
                  i18nKey='warehouse_name'
                  required={true}
                  type='text'
                  value={name}
                  setValue={setName}
                  autoComplete='register name'
                />
              </div>
              <div className='ml-4 input-wrapper half-width'>
                <InputForm
                  i18nKey='warehouse_short_name'
                  required={true}
                  type='text'
                  value={shortName}
                  setValue={setShortName}
                  autoComplete='register short_name'
                  disabled={isEditMode? true : false}
                />
              </div>
            </div>
            <div className='flex'>
              <div className='input-wrapper'>
                <SelectInputForm
                  i18nKey='company_name'
                  disabled={isEditMode? true : false } //新規Create時のみ編集可
                //  disabled={userRole !== 'admin' || isEditMode? true : false}
                  value={belongsCompanyListNo}
                  onChange={setBelongsCompanyListNo}
                  options={companiesList.map(value => value['name'])}
                />
              </div>

              <div className='ml-4 input-wrapper'>
                <InputForm
                  i18nKey='limit_simulation_sec_short'
                  required={true}
                  type='text'
                  value={limitSimulationSec}
                  setValue={setlimitSimulationSec}
                  //autoComplete='register short_name'
                />
              </div>
            </div>

            {isInProgress && (
              <div>
                <CircularProgress
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%'
                  }}
                />
              </div>
            )}
          </div>

          <div className='flex'>
            <div className='input-wrapper mr-4'>
              <ErrorMessage i18nKey={errorMessage} />
            </div>
          </div>
          <ModalButtonsSet
            confirmButtonI18nKey='register'
            submitHandler={handleRegisterWarehouse}
            cancelHandler={closeEditModal}
            disabled={disabled}
          />
        </div>
      </div>
    )
  }

export default EditWarehouseModal
